"use client";

import React from "react";

export default function Loader() {
  return (
    <div className="fixed top-0 left-0 w-full h-full 
    bg-white/50 
    backdrop-blur-[2px]
    flex flex-col items-center justify-center 
    z-[9999] gap-8">
  
      <div className="relative w-32 h-32">
        {/* Animated hanger silhouette */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            className="animate-swing"
            style={{
              transformOrigin: "center top",
            }}
          >
            {/* Hanger hook */}
            <path
              d="M40 8 Q45 5 45 10 Q45 15 40 15"
              stroke="#4f46e5"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
            />
            
            {/* Hanger bar */}
            <line
              x1="40"
              y1="15"
              x2="20"
              y2="35"
              stroke="#4f46e5"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <line
              x1="40"
              y1="15"
              x2="60"
              y2="35"
              stroke="#4f46e5"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            
            {/* Bottom bar */}
            <line
              x1="20"
              y1="35"
              x2="60"
              y2="35"
              stroke="#4f46e5"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>

        {/* Orbiting fashion elements */}
        <div className="absolute inset-0 animate-spin-slow">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-2">
            <div className="w-2 h-2 rounded-full bg-pink-400" />
          </div>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-2">
            <div className="w-2 h-2 rounded-full bg-purple-400" />
          </div>
          <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2">
            <div className="w-2 h-2 rounded-full bg-rose-400" />
          </div>
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2">
            <div className="w-2 h-2 rounded-full bg-fuchsia-400" />
          </div>
        </div>

        {/* Outer rotating ring */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-pink-300 border-r-pink-300 animate-spin opacity-50" />
      </div>

      {/* Brand section */}
      <div className="text-center space-y-3">
        <h1 className="text-4xl font-bold tracking-wider text-slate-900">
          LAZY<span className="text-[#4f46e5]">X</span>
        </h1>
        <p className="text-sm font-medium text-slate-600 tracking-wide uppercase animate-pulse">
          Curating Your Style
        </p>
        
        {/* Loading dots */}
        <div className="flex items-center justify-center gap-2 mt-4">
          <div className="w-2 h-2 rounded-full bg-[#4f46e5] animate-bounce" style={{ animationDelay: "0ms" }} />
          <div className="w-2 h-2 rounded-full bg-[#4f46e5] animate-bounce" style={{ animationDelay: "150ms" }} />
          <div className="w-2 h-2 rounded-full bg-[#4f46e5] animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>

      <style jsx>{`
        @keyframes swing {
          0%, 100% {
            transform: rotate(-8deg);
          }
          50% {
            transform: rotate(8deg);
          }
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .animate-swing {
          animation: swing 2s ease-in-out infinite;
        }

        .animate-spin-slow {
          animation: spin-slow 4s linear infinite;
        }
      `}</style>
    </div>
  );
}